/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import React from 'react';
import { Link } from 'react-router-dom';

import ContactIcons from '../Contact/ContactIcons';

const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => (
  <section id="sidebar">
    <section id="intro">
      <Link to="/" className="logo">
        <img src={`${PUBLIC_URL}/images/me.jpg`} alt="Ajith Joseph - AI Lead Engineer" />
      </Link>
      <header>
        <h2>Ajith Joseph</h2>
        <p><a href="mailto:contact@ajithjoseph.com">contact@ajithjoseph.com</a></p>
      </header>
    </section>

    <section className="blurb">
      <h2>About</h2>
      <p>Hi, I&apos;m Ajith Joseph, an <strong>AI Lead Engineer</strong> based in Bengaluru with <strong>13+ years in software engineering</strong>, including 3+ years building Agentic AI, RAG, and LLM systems. I design production LLM agents with LangChain, n8n, and the Model Context Protocol (MCP), backed by a full-stack foundation in React and .NET Core. Participant of Google Chrome&apos;s Built-in AI Challenge 2024 and <a href="https://www.linkedin.com/posts/ajithjozef_watsonxai-ibmtechxchange-watsonxhackathon-activity-7256538925840637952-0lau/" target="_blank" rel="noreferrer">IBM Watsonx Top 100 scorer</a>.
      </p>
      <ul className="actions">
        <li>
          {!window.location.pathname.includes('/resume') ? <Link to="/resume" className="button">Learn More</Link> : <Link to="/about" className="button">About Me</Link>}
        </li>
      </ul>
    </section>

    <section id="footer">
      <ContactIcons />
      <p className="copyright">&copy; Ajith Joseph <Link to="/">ajithjoseph.com</Link>.</p>
    </section>
  </section>
);

export default SideBar;
